import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";
import Breadcrumbs from "../components/Breadcrumbs";
import { ArticleCard } from "../components/ArticleCard";
import { fetchAuthor, fetchArticles } from "../lib/api";

export default function Author() {
  const { slug } = useParams();
  const [author, setAuthor] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchAuthor(slug).then(setAuthor).catch(() => setAuthor(null));
    fetchArticles({ author: slug, limit: 40 }).then((d) => setItems(d.items || []));
  }, [slug]);

  return (
    <Layout>
      <MetaTags title={author?.name || "Author"} description={author?.bio} image={author?.image} />
      <section className="border-b border-[#121212] bg-white">
        <div className="ceg-container py-10">
          <Breadcrumbs items={[{ to: "/", label: "Home" }, { label: author?.name || "Author" }]} />
          <div className="mt-6 grid md:grid-cols-12 gap-6 items-center">
            {author?.image && (
              <div className="md:col-span-3">
                <img src={author.image} alt={author.name} className="w-32 h-32 object-cover border border-[#121212]" />
              </div>
            )}
            <div className="md:col-span-9">
              <p className="ceg-overline">Author</p>
              <h1 className="font-['Outfit'] font-black tracking-tighter text-5xl md:text-6xl mt-2">{author?.name || slug}</h1>
              {author?.bio && <p className="mt-3 text-lg text-[#5C5C5C] max-w-2xl">{author.bio}</p>}
            </div>
          </div>
        </div>
      </section>
      <section className="ceg-container py-12">
        <p className="ceg-overline mb-6">{items.length} articles</p>
        <div className="grid grid-cols-12 gap-6">
          {items.map((a, i) => (
            <div key={a.slug} className="col-span-12 sm:col-span-6 lg:col-span-4">
              <ArticleCard article={a} index={i} />
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
